<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <!--search-->
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.roleName == 'ADMIN' || user.roleName == 'FINANCE_MANAGER'
              "
            >
              <v-select
                :items="activeWarehouseList"
                label="Choose Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!--stock take list-->
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="stockTakeList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  color="primary"
                  :loading="takeLoading"
                  @click="takeStock(props.item.id)"
                >
                  Take
                </v-btn>
              </td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.warehouse.name }}</td>
              <td>
                {{ props.item.createdDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.createdBy }}</td>
              <td>
                <v-btn color="primary" @click="showDetail(props.item)">
                  Detail
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--stock take detail dialog-->
    <v-dialog
      v-model="showStockTakeDetailListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <!--search-->
        <v-card-title>
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-autocomplete
                :items="selectedBinList"
                v-model="detailQueryParams.binIds"
                @click="showBins"
                label="Bin"
                item-text="name"
                item-value="id"
                menu-props="auto"
                autocomplete
                multiple
                class="mr-2"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="productCode"
                v-model="detailQueryParams.productCode"
                label="Product Code"
                type="text"
                class="mr-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="productName"
                v-model="detailQueryParams.productName"
                label="Product Name"
                type="text"
                class="mr-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-select
                :items="activeBrandList"
                v-model="detailQueryParams.brandId"
                label="Brand"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-select
                :items="activeCategoryList"
                v-model="detailQueryParams.categoryId"
                label="Category"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                class="mr-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-select
                :items="activeCategoryGroupList"
                v-model="detailQueryParams.categoryGroupId"
                label="Category Group"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                class="mr-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-select
                :items="activeProductGroupList"
                v-model="detailQueryParams.productGroupId"
                label="Product Group"
                item-text="name"
                item-value="id"
                menu-props="auto"
                :hide-no-data="true"
                class="mr-2"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-btn outline color="primary" @click="onSearchDetail"
                >Search<v-icon right>search</v-icon></v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <!--summary-->
            <v-flex xs12>
              <v-card>
                <v-card-text class="font-weight-bold">
                  <div>
                    <span style="padding-left: 20px">Warehouse Name: </span>
                    <v-chip
                      ><span>{{ warehouseName }}</span></v-chip
                    >

                    <span style="padding-left: 20px">Total Qty: </span>
                    <v-chip
                      ><span>{{ totalQty | decFormat(6) }}</span></v-chip
                    >

                    <span style="padding-left: 20px">Total Amount: </span>
                    <v-chip
                      ><span>{{ totalAmount | decFormat(6) }}</span></v-chip
                    >

                    <v-btn
                      color="success"
                      :loading="buttonLoading"
                      @click="exportAllStockTakeDetail"
                      >EXPORT ALL</v-btn
                    >
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <!--stock take detail list-->
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :must-sort="true"
                  :headers="detailHeaders"
                  :items="stockTakeDetailList"
                  class="elevation-1"
                  :loading="showDetailListLoading"
                  :total-items="detailTotalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="detailPagination"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.binName }}</td>
                    <td>{{ props.item.productCode }}</td>
                    <td>{{ props.item.productName }}</td>
                    <td>
                      <v-icon v-if="props.item.isWIP" medium color="green"
                        >check_circle</v-icon
                      >
                      <v-icon v-else medium color="red">cancel</v-icon>
                    </td>
                    <td
                      v-if="
                        props.item.categoryGroupName &&
                          props.item.productGroupName
                      "
                    >
                      {{ props.item.brandName }}/{{
                        props.item.categoryName
                      }}/{{ props.item.categoryGroupName }}/{{
                        props.item.productGroupName
                      }}
                    </td>
                    <td
                      v-else-if="
                        !props.item.categoryGroupName &&
                          props.item.productGroupName
                      "
                    >
                      {{ props.item.brandName }}/{{
                        props.item.categoryName
                      }}/-/{{ props.item.productGroupName }}
                    </td>
                    <td
                      v-else-if="
                        props.item.categoryGroupName &&
                          !props.item.productGroupName
                      "
                    >
                      {{ props.item.brandName }}/{{
                        props.item.categoryName
                      }}/{{ props.item.categoryGroupName }}/-
                    </td>
                    <td v-else>
                      {{ props.item.brandName }}/{{
                        props.item.categoryName
                      }}/-/-
                    </td>
                    <td>{{ props.item.factor }}/({{ props.item.unitName }})</td>
                    <td>{{ props.item.unitCost | decFormat(6) }}</td>
                    <td>{{ props.item.qty | decFormat(6) }}</td>
                    <td>{{ props.item.qcNo }}</td>
                    <td>{{ props.item.batchNo }}</td>
                    <td>
                      {{ props.item.mfgDateInMilliSeconds | formatMsDate }}
                    </td>
                    <td>
                      {{ props.item.expDateInMilliSeconds | formatMsDate }}
                    </td>
                    <td>
                      {{
                        (props.item.qty * props.item.unitCost) | decFormat(6)
                      }}
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--bin filter dialog-->
    <v-dialog v-model="showBinListDialog" scrollable max-width="1000px">
      <v-card>
        <!--search-->
        <v-card-title>
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Bin Name"
                type="text"
                v-model="binQueryParams.name"
                class="mr-2"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-btn outline color="primary" @click="onSearchBin">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <!--bin list-->
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-data-table
              :must-sort="true"
              :headers="binHeaders"
              :items="binList"
              class="elevation-1"
              :loading="showBinListLoading"
              :total-items="binTotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="binPagination"
              select-all
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedBinList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.name }}</a>
                </td>
                <td v-if="props.item.warehouse">
                  {{ props.item.warehouse.name }}
                </td>
                <td v-else></td>
                <td>{{ props.item.binType.typeName }}</td>
                <td>{{ props.item.maxCapacity }}</td>
                <td>{{ props.item.minCapacity }}</td>
                <td>{{ props.item.stockBalance }}</td>
                <td>
                  {{ props.item.selfExpireInMilliSeconds | formatMsDate }}
                </td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setBin">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseMessage }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { stockTakeService } from "../../services/stock-take-service";
import { warehouseService } from "../../services/warehouse-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";
import { productGroupService } from "../../services/product-group-service";
import { categoryGroupService } from "../../services/category-group-service";
import { binService } from "../../services/bin-service";
import { commonService } from "../../services/common-service";

export default {
  name: "StockTakeList",
  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    showDetailListLoading: false,
    showBinListLoading: false,
    showStockTakeDetailListDialog: false,
    showBinListDialog: false,
    takeLoading: false,
    buttonLoading: false,
    messageDialogBox: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Warehouse Management",
        disabled: true,
      },
      {
        text: "Stock Take",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", align: "center", sortable: false },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "IssueNo", value: "issueNo" },
      { text: "Warehouse", value: "warehouse.name" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
      { text: "Detail", sortable: false },
    ],
    detailHeaders: [
      { text: "Bin", align: "left", value: "bin_id" },
      { text: "Product Code", value: "p.code" },
      { text: "Product Name", value: "p.name" },
      { text: "WIP", value: "is_wip" },
      { text: "Brand/Category/Category Group/Product Group", sortable: false },
      { text: "Basic Unit", sortable: false },
      { text: "Unit Cost", value: "unit_cost" },
      { text: "Qty", value: "qty" },
      { text: "QC No", align: "left", value: "qcNo", sortable: false },
      { text: "Batch No", align: "left", value: "batchNo", sortable: false },
      { text: "MFG Date", align: "left", value: "mfgDate", sortable: false },
      { text: "EXP Date", align: "left", value: "expDate", sortable: false },
      { text: "Total Amount", sortable: false },
    ],
    binHeaders: [
      { text: "Name", sortable: false },
      { text: "Warehouse", sortable: false },
      { text: "Bin Type", sortable: false },
      { text: "Max Capacity", sortable: false },
      { text: "Min Capacity", sortable: false },
      { text: "Stock Balance", sortable: false },
      { text: "Self Expire", sortable: false },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      warehouseId: "",
    },
    detailQueryParams: {
      id: "",
      binIds: [],
      productCode: "",
      productName: "",
      brandId: "",
      categoryId: "",
      categoryGroupId: "",
      productGroupId: "",
    },
    binQueryParams: {
      name: "",
      warehouseId: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issueDate",
      totalItems: 0,
    },
    detailPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "bin_id",
      totalItems: 0,
    },
    binPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    detailTotalRows: 0,
    binTotalRows: 0,
    findAll: { id: "", name: "---All---" },
    activeWarehouseList: [],
    binList: [],
    selectedBinList: [],
    activeBrandList: [],
    activeCategoryList: [],
    activeProductGroupList: [],
    activeCategoryGroupList: [],
    stockTakeList: [],
    stockTakeDetailList: [],
    warehouseName: "",
    responseMessage: "",
    totalQty: 0,
    totalAmount: 0.0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockTakeList();
      },
      deep: true,
    },
    detailPagination: {
      handler() {
        if (this.detailQueryParams.id) {
          this.getStockTakeDetailList();
        }
      },
      deep: true,
    },
  },
  created() {
    if (
      this.user.role.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "WAREHOUSE_STAFF" ||
      this.user.role.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.warehouseId = this.user.warehouseId;
    } else if (
      this.user.role.roleName == "PRODUCTION_MANAGER" ||
      this.user.role.roleName == "ASSET_MANAGER"
    ) {
      this.queryParams.warehouseId = this.user.shop.warehouseId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.rowsPerPage = this.$route.query.size;
    }

    this.getActiveWarehouseList();
    this.getActiveBrandList();
    this.getActiveCategoryList();
    this.getActiveProductGroupList();
    this.getActiveCategoryGroupList();
  },
  methods: {
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.activeWarehouseList = res.data;
          this.activeWarehouseList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveBrandList() {
      brandService
        .getBrandsByStatus("ACTIVE")
        .then((res) => {
          this.activeBrandList = res.data;
          this.activeBrandList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveCategoryList() {
      categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.activeCategoryList = res.data;
          this.activeCategoryList.splice(
            0,
            0,
            JSON.parse(JSON.stringify(this.findAll))
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveProductGroupList() {
      productGroupService
        .getProductGroupsByStatus("ACTIVE")
        .then((res) => {
          this.activeProductGroupList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getActiveCategoryGroupList() {
      categoryGroupService
        .getCategoryGroupsByStatus("ACTIVE")
        .then((res) => {
          this.activeCategoryGroupList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "stock-takes", query: this.queryParams });
      this.getStockTakeList();
    },
    getStockTakeList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockTakeService
        .getStockTakeList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockTakeList = res.data.stockTakeList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/stock-take-register");
    },
    takeStock(stockTakeId) {
      if (!this.takeLoading) {
        this.takeLoading = true;
        stockTakeService
          .takeStock(stockTakeId)
          .then((res) => {
            console.log(res.data);
            //this.responseMessage = "Taking stock is finished.";
            //this.messageDialogBox = true;
            this.takeLoading = false;
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseMessage = err.response.data.message;
              this.messageDialogBox = true;
              this.takeLoading = false;
            }
          });
      }
    },
    showDetail(stockTake) {
      //for stock take detail summary
      this.warehouseName = stockTake.warehouse.name;

      //set stock take detail query params
      this.detailQueryParams.id = stockTake.id;
      this.detailQueryParams.binIds = "";
      this.detailQueryParams.productCode = "";
      this.detailQueryParams.productName = "";
      this.detailQueryParams.brandId = "";
      this.detailQueryParams.categoryId = "";
      this.detailQueryParams.categoryGroupId = "";
      this.detailQueryParams.productGroupId = "";
      this.binQueryParams.warehouseId = stockTake.warehouse.id;
      this.selectedBinList = [];
      this.getStockTakeDetailList().then(
        (this.showStockTakeDetailListDialog = !this
          .showStockTakeDetailListDialog)
      );
    },
    getStockTakeDetailList() {
      this.showDetailListLoading = true;
      let order = this.detailPagination.descending ? "desc" : "asc";
      return stockTakeService
        .getStockTakeDetailList(
          this.detailQueryParams,
          this.detailPagination.page,
          this.detailPagination.rowsPerPage,
          this.detailPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.stockTakeDetailList = res.data.stockTakeDetailList;
            this.totalQty = res.data.totalQty;
            this.totalAmount = res.data.totalAmount;
            this.detailTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showDetailListLoading = false;
        });
    },
    onSearchDetail() {
      this.detailQueryParams.page = this.detailPagination.page;
      this.detailQueryParams.size = this.detailPagination.rowsPerPage;
      this.getStockTakeDetailList();
    },
    exportAllStockTakeDetail() {
      this.buttonLoading = true;
      stockTakeService
        .exportStockTakeDetailExcel(this.detailQueryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    showBins() {
      //clean query params
      this.binQueryParams.name = "";
      this.detailQueryParams.binIds = [];
      this.selectedBinList = [];

      this.getBins().then((this.showBinListDialog = !this.showBinListDialog));
    },
    getBins() {
      this.showBinListLoading = true;
      let order = this.binPagination.descending ? "desc" : "asc";
      return binService
        .getBinList(
          this.binQueryParams,
          this.binPagination.page,
          this.binPagination.rowsPerPage,
          this.binPagination.sortBy + "," + order
        )
        .then((res) => {
          this.binList = res.data.binList;
          this.binTotalRows = res.data.totalElements;
        })
        .finally(() => {
          this.showBinListLoading = false;
        });
    },
    onSearchBin() {
      this.binQueryParams.page = this.binPagination.page;
      this.binQueryParams.size = this.binPagination.rowsPerPage;
      this.getBins();
    },
    setBin() {
      if (this.selectedBinList.length) {
        this.detailQueryParams.binIds = [];
        this.selectedBinList.forEach((element) => {
          if (!this.detailQueryParams.binIds.includes(element.id))
            this.detailQueryParams.binIds.push(element.id);
        });
      }
      this.showBinListDialog = !this.showBinListDialog;
    },
    toggleAll() {
      if (this.selectedBinList.length) {
        this.selectedBinList = [];
      } else {
        this.selectedBinList = this.binList.slice();
      }
    },
  },
};
</script>
